import { parseWellLogsManagerWidgetInternalState } from 'src/pages/dashboard/features/well-logs-manager-widget/parseWellLogsManagerWidget';

import type { TSerializedWidget } from 'src/entities/workspace/types';
import type { WellLogsManagerWidgetEntity } from 'src/pages/dashboard/features/well-logs-manager-widget/WellLogsManagerWidget.entity';

import { baseWidgetApplyChanges } from './baseWidgetApplyChanges';

export function wellLogsManagerApplyChanges(
  widget: WellLogsManagerWidgetEntity,
  changes: TSerializedWidget,
  index: number
) {
  baseWidgetApplyChanges(widget, changes, index);

  const internalState = parseWellLogsManagerWidgetInternalState(changes.internalState);

  widget.setWellId(internalState.wellId);
  widget.setStateParams(internalState.stateParams);
}
